export const proTypes = {
  SET_FORM_DETAIL: "@@pro/@@SET_FORM_DETAIL",
  CLEAN_SET_FORM_DETAIL: "@@pro/@@CLEAN_SET_FROM_DETAIL",
}
